/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Nottitle1Inputs */

const id_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang BUKAN egdata.app`)
};

const ms_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang egdata.app BUKAN`)
};

const da_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad egdata.app IKKE er`)
};

const de_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was egdata.app NICHT ist`)
};

const en_us2_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What egdata.app is NOT`)
};

const es_es2_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que egdata.app NO es`)
};

const es_mx2_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que egdata.app NO es`)
};

const fil_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang egdata.app HINDI`)
};

const fr_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qu'egdata.app n'est PAS`)
};

const it_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa egdata.app NON è`)
};

const hu_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit NEM az egdata.app`)
};

const nl_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat egdata.app NIET is`)
};

const no_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva egdata.app IKKE er`)
};

const pl_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czym egdata.app NIE jest`)
};

const pt_br2_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que egdata.app NÃO É`)
};

const pt_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o egdata.app NÃO é`)
};

const ro_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce NU este egdata.app`)
};

const fi_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä egdata.app EI ole`)
};

const sv_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad egdata.app INTE är`)
};

const vi_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app KHÔNG phải là gì`)
};

const tr_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app NE DEĞİLDİR`)
};

const cs_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co egdata.app NENÍ`)
};

const bg_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какво egdata.app НЕ е`)
};

const ru_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чем egdata.app НЕ является`)
};

const uk_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чим egdata.app НЕ є`)
};

const ar_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما ليس egdata.app`)
};

const hi_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app क्या नहीं है`)
};

const th_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่ egdata.app ไม่ใช่`)
};

const ja_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app ではないもの`)
};

const zh_cn2_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 不是什么`)
};

const zh_hant1_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 不是什麼`)
};

const ko_privacy_nottitle1 = /** @type {(inputs: Privacy_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app이 아닌 것`)
};

/**
* | output |
* | --- |
* | "What egdata.app is NOT" |
*
* @param {Privacy_Nottitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_nottitle1 = /** @type {((inputs?: Privacy_Nottitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Nottitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_nottitle1(inputs)
	if (locale === "ms") return ms_privacy_nottitle1(inputs)
	if (locale === "da") return da_privacy_nottitle1(inputs)
	if (locale === "de") return de_privacy_nottitle1(inputs)
	if (locale === "en-US") return en_us2_privacy_nottitle1(inputs)
	if (locale === "es-ES") return es_es2_privacy_nottitle1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_nottitle1(inputs)
	if (locale === "fil") return fil_privacy_nottitle1(inputs)
	if (locale === "fr") return fr_privacy_nottitle1(inputs)
	if (locale === "it") return it_privacy_nottitle1(inputs)
	if (locale === "hu") return hu_privacy_nottitle1(inputs)
	if (locale === "nl") return nl_privacy_nottitle1(inputs)
	if (locale === "no") return no_privacy_nottitle1(inputs)
	if (locale === "pl") return pl_privacy_nottitle1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_nottitle1(inputs)
	if (locale === "pt") return pt_privacy_nottitle1(inputs)
	if (locale === "ro") return ro_privacy_nottitle1(inputs)
	if (locale === "fi") return fi_privacy_nottitle1(inputs)
	if (locale === "sv") return sv_privacy_nottitle1(inputs)
	if (locale === "vi") return vi_privacy_nottitle1(inputs)
	if (locale === "tr") return tr_privacy_nottitle1(inputs)
	if (locale === "cs") return cs_privacy_nottitle1(inputs)
	if (locale === "bg") return bg_privacy_nottitle1(inputs)
	if (locale === "ru") return ru_privacy_nottitle1(inputs)
	if (locale === "uk") return uk_privacy_nottitle1(inputs)
	if (locale === "ar") return ar_privacy_nottitle1(inputs)
	if (locale === "hi") return hi_privacy_nottitle1(inputs)
	if (locale === "th") return th_privacy_nottitle1(inputs)
	if (locale === "ja") return ja_privacy_nottitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_nottitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_nottitle1(inputs)
	return ko_privacy_nottitle1(inputs)
});
export { privacy_nottitle1 as "privacy.notTitle" }